import React, {useContext} from "react";
import {withStyles} from "@material-ui/core/styles";
import TreeItem from "@material-ui/lab/TreeItem";
import {TransitionComponent} from "../../../../../ApplicationTree/Tree/TreeUtils";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../../ToolBar/ToolBarUtils/ItemTypes";
import RenderComponents from "../RenderByType/RenderComponents";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
// import SearchInput from "./SearchInput";

const StyledTreeItem = withStyles((theme) => ({
    iconContainer: {
        '& .close': {
            opacity: 0.3,
        },
    },
    group: {
        marginLeft: 7,
        paddingLeft: 8,
        borderLeft: `1px dashed ${theme.palette.text.primary}`,
    },
    label: {
        '& $searchButton': {
            visibility: 'hidden'
        },
        '&:hover': {
            '& $searchButton': {
                visibility: 'visible'
            }
        }
    },
    searchButton: {
        display: 'flex',
        alignItems: 'center'
    }
}))((props) => {
    const {
        onDropComponent, onDropMultipleComponents, onMoveComponent
    } = useContext(ScreenDesignerContextNew);
    const {component: {children} = {}, path, parentIndex} = props;
    const hasChildren = children && children.length;
    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.column,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            let newItem = {...item};
            if (didDrop) {
                return;
            }
            if (item.children && item.type === 'panel') {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: []
                    }]
                };
            }
            if (item.dragType === 'multiple') {
                onDropMultipleComponents(item.component, 0, `${path}.children`);
                return
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    item.component = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(item.component, item.from, `${path}.children`, children.length, item.index, parentIndex);
                return
            }

            onDropComponent(newItem, children?.length || 0, `${path}.children`)
        }
    });
    return (
        <TreeItem
            {...props}
            label={
                <div
                    ref={drop}
                    className={props.classes.label}
                    style={{
                        width: !hasChildren ? '100px' : 'auto',
                        height: !hasChildren ? '30px' : 'auto',
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    {hasChildren ? (
                        children.map((item, index) => {
                            return (
                                <RenderComponents
                                    key={index}
                                    type={item.type}
                                    item={item}
                                    index={index}
                                    path={`${path}.children.${index}`}
                                    parentPath={path}
                                />
                            )
                        })
                    ) : (
                        isOverCurrent && (
                            <div style={{background: '#009688', height: 10, alignSelf: 'center', width: '100%'}}>

                            </div>
                        )
                    )}

                </div>}
            TransitionComponent={TransitionComponent}
        />
    )
});
export default StyledTreeItem;
